import { cloneDeep, each, filter, range } from 'lodash';

export default class InfoService {
/** @ngInject **/
  constructor(
    $http,
    $q,
    ngAuthSettings,
    cacheService,
  ) {
    this.serviceBaseUri = ngAuthSettings.apiServiceBaseUri + 'info/';
    this.$http = $http;
    this.ngAuthSettings = ngAuthSettings;
    this.cacheService = cacheService;
    this.$q = $q;
  }

  getTimeZones() {
    const cachedValue = this.cacheService.get('infoService.timezones');

    if (cachedValue) {
      return this.$q.when(cachedValue);
    } else {
      const url = this.serviceBaseUri + 'timezones';

      return this.$http.get(url, { cache: true })
        .then((response) => {
          const data = response.data;
          response.data = [
            ...data.filter((timezone) => this.#priorityTimezone(timezone)),
            ...data.filter((timezone) => !this.#priorityTimezone(timezone))
          ];
          this.cacheService.set('infoService.timezones', response, {
            persistence: true
          });

          return response;
        });
    }
  }

  getDisplayTimezone(timeZoneId) {
    return this.getTimeZones()
      .then((response) => {
        if (response.data) {
          return response.data.find((timezone) => {
            return timezone.id == timeZoneId;
          }).display;
        }
      });
  }

  clearCountriesCache(){
    this.cacheService.remove('infoService.countries.with.address.check');
    this.cacheService.remove('infoService.countries');
  }

  getCountriesWithAddressCheck() {
    return this.getCountries().then((vals)=> {
     
      //we have moved the logic to protect numbers to the purchase time and not the 
      //choice time, so we are marking all these as true and allowing the user to attempt to 
      //buy the number in the case the number can not be purchased, the user will receive a message from
      //the server telling them to contact sales for a number
      if(vals && vals.data){
        const response = cloneDeep(vals);

        each(response.data, (address) => {
          address.hasLocalNumbers = true;
          address.addressRequirementFullfilledForLocalNumbers = true;
          address.addressRequirementFullfilledForTollFreeNumbers = true;
        });

        return response;
      }

      return vals;
    });
    // UNCOMENT TO ENABLE ADDRESS VERIFICATION ON CLIENT SIDE
    // var cachedValue = this.cacheService.get('infoService.countries.with.address.check');
    // if (cachedValue) {
    //   return $q.when(cachedValue);
    // } else {
    //   var url = ngAuthSettings.apiServiceBaseUri+accountsService.currentAccountId+'/addresses/countries';
    //   return $http.get(url, { cache: false })
    //     .then(function (response) {
    //       this.cacheService.set('infoService.countries.with.address.check', response, {
    //         persistence: true,
    //         expireAfterSeconds: 60 *15
    //       });
    //       return response;
    //     });
    // }
  }

  getCountries() {
    const cachedValue = this.cacheService.get('infoService.countries');
    if (cachedValue) {
      return this.$q.when(cachedValue);
    } else {
      const url = this.ngAuthSettings.apiServiceBaseUri + 'info/countries';
      return this.$http.get(url, { cache: false })
        .then((response) => {
          this.cacheService.set('infoService.countries', response, {
            persistence: true,
            expireAfterSeconds: 60 * 60 * 24
          });

          return response;
        });
    }
  }

  getConversionSettings(isPayout) {
    isPayout = isPayout || false;
    
    function filterSettings(vals) {
      const response = cloneDeep(vals);
      if (isPayout) {
        response.data = filter(response.data, (val) => { return !val.conversionOnly; });
        return response;
      }
      else {
        response.data = filter(response.data, (val) => { return !val.payoutOnly; });
        return response;
      }
    }

    const cachedValue = this.cacheService.get('infoService.conversionsettingsv4');

    if (cachedValue) {
      return this.$q.when(filterSettings(cachedValue));
    } else {
      const url = this.serviceBaseUri + 'conversionsettings';

      return this.$http.get(url, { cache: true })
        .then((response) => {
          this.cacheService.set('infoService.conversionsettingsv4', response, {
            persistence: true
          });

          return filterSettings(response);
        });
    }
  }

  getOfferSupportedLanguages() {
    const cachedValue = this.cacheService.get('infoService.offerLanguages');

    if (cachedValue) {
      return this.$q.when(cachedValue);
    } else {
      const url = this.ngAuthSettings.apiServiceBaseUri + 'info/languages';

      return this.$http.get(url, { cache: false })
        .then((response) => {
          this.cacheService.set('infoService.offerLanguages', response, {
            persistence: true,
            expireAfterSeconds: 60 * 60 * 24
          });
          return response;
        });
    }
  }

  getOfferCategories(accountId) {
    const cachedValue = this.cacheService.get('infoService.offerCategories');

    if (cachedValue) {
      return this.$q.when(cachedValue);
    } else {
      const url = this.ngAuthSettings.apiServiceBaseUri + accountId + '/info/offercategories';

      return this.$http.get(url).then((response) => {
        this.cacheService.set('infoService.offerCategories', response, {
          persistence: true,
          expireAfterSeconds: 60 * 60
        });
        return response;
      });
    }
  }

  getCreditCardExpirationYearList() {
    const currentYear = new Date().getFullYear();
    return range(currentYear, currentYear + 20);
  }

  getStates() {
    return ['AK', 'AL', 'AR', 'AZ', 'CA', 'CO', 'CT', 'DC', 'DE', 'FL', 'GA', 'GU', 'HI', 'IA', 'ID', 'IL', 'IN', 'KS', 'KY', 'LA', 'MA', 'MD', 'ME', 'MH', 'MI', 'MN', 'MO', 'MS', 'MT', 'NC', 'ND', 'NE', 'NH', 'NJ', 'NM', 'NV', 'NY', 'OH', 'OK', 'OR', 'PA', 'PR', 'PW', 'RI', 'SC', 'SD', 'TN', 'TX', 'UT', 'VA', 'VI', 'VT', 'WA', 'WI', 'WV', 'WY'];
  }

  getOfferVisibilityValues() {
    return [
      { name: 'Private', value: 'private' },
      { name: 'Account', value: 'account' },
      // { name: 'Public', value: 'public' }, // Not supported yet
    ];
  }

  #priorityTimezone(timezone) {
    return timezone.id == 'Pacific Standard Time' || timezone.id == 'Eastern Standard Time' || timezone.id == 'Central Standard Time';
  }
}